export function sortObjectBy(
  object: Record<string, any>,
  orderedKeys: string[],
): Record<string, any> {
  return Object.keys(object)
    .sort((a, b) => {
      return orderedKeys.indexOf(a) - orderedKeys.indexOf(b);
    })
    .reduce((obj, key) => ({ ...obj, [key]: object[key] }), {});
}
